import React, { useState, useEffect } from 'react'
import Form from "../../../layouts/Form";
import { Grid, InputAdornment, makeStyles, ButtonGroup, Button as MuiButton } from '@material-ui/core';
import { Input, Select, Button } from "../../../controls";
import ReplayIcon from '@material-ui/icons/Replay';
import PaidIcon from '@mui/icons-material/Paid';
import ReorderIcon from '@material-ui/icons/Reorder';
import { createAPIEndpoint, ENDPIONTS } from "../../../api";
import { roundTo2DecimalPoint } from "../../../utils";
import Popup from '../../../layouts/Popup';
import Notification from "../../../layouts/Notification";
import InputLabel from '@mui/material/InputLabel';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { styled } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';

const useStyles = makeStyles(theme => ({
    adornmentText: {
        '& .MuiTypography-root': {
            color: '#f3b33d',
            fontWeight: 'bolder',
            fontSize: '1.5em'
        }
    },
    submitButtonGroup: {
        backgroundColor: '#6666ff',
        color: theme.palette.common.white,
        margin: theme.spacing(1),
        '& .MuiButton-label': {
            textTransform: 'none'
        },
        '&:hover': {
            backgroundColor: '#f3b33d',
        }
    },
    formatoCelda: {
        backgroundColor: '#ff0000',
        color: '#ffffff',
        margin: theme.spacing(1),
        fontSize: '7'
    }
}))


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        backgroundColor: "#595959",
        color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 'small',

    },
}));



const getFreshModelObject2 = () => ({
    idusuario: 0,
    fecha: 'none'
})

export default function AlumnosInscritosSiguienteCiclo(props) {

    //console.log("---------***>" + JSON.stringify(props));

    const { values, setValues, errors, setErrors, handleInputChange, resetFormControls } = props;
    const classes = useStyles();

    const [alumnoList, setAlumnoList] = useState([]);
    const [notify, setNotify] = useState({ isOpen: false });
    const [enviarpago, setEnviarpago] = useState(false);

    const [idusuario, setIdusuario] = useState(0);



    useEffect(() => {
        setIdusuario(parseInt(sessionStorage.getItem('idusuario')));


        //console.log("CARGA HISTORIAL PAGO ---> ");
        var f = new Date();
        var fecini = (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate());
        var fecfin = (f.getFullYear() + "-" + (f.getMonth() + 1) + "-" + f.getDate());

        //var parametros = "?idusuario=" + sessionStorage.getItem('idusuario') + "&fecini=" + fecini + "&fecfin=" + fecfin;

        createAPIEndpoint(ENDPIONTS.ALUMNOS_SIGUIENTE_CICLO).fetchAlumnosSiguienteCiclo()
            .then(res => {
                let alumnoList = res.data.map(item => ({
                    idalumno: item.idalumno,
                    nombres: item.nombres,
                    apellidopaterno: item.apellidopaterno,
                    apellidomaterno: item.apellidomaterno,
                    nivelsiguienteciclo: item.nivelsiguienteciclo,
                    gradosiguienteciclo: item.gradosiguienteciclo
                }));

                //console.log(JSON.stringify(pagoList));

                setAlumnoList(alumnoList);
            })
            .catch(err => console.log(err))


    }, [])



    /*
    useEffect(() => {
        if (orderId == 0) {
            //console.log("ingresar por order id");
            //resetFormControls();
        } else {
            createAPIEndpoint(ENDPIONTS.ORDER).fetchById(orderId)
                .then(res => {
                    setValues(res.data);
                    setErrors({});
                })
                .catch(err => console.log(err))
        }
    }, [orderId]);

    useEffect(() => {
        setValues({
            ...values,
            idalumno: alumnoid,
            idusuario: sessionStorage.getItem('idusuario'),
            alias: sessionStorage.getItem('alias'),
        })

    }, [alumnoid]);

    useEffect(() => {
        //console.log("---CCAAAA>" + correo2);

        setValues({
            ...values,
            correo: correo2
        })

    }, [correo2]);
    */







    const validateForm = () => {
        debugger;
        let temp = {};

        temp.factura = values.factura != "none" ? "" : "¡Este campo es obligatorio!";
        temp.customerId = values.customerId != 0 ? "" : "¡Este campo es obligatorio!";
        temp.pMethod = values.pMethod != "none" ? "" : "¡Este campo es obligatorio!";
        temp.orderDetails = values.orderDetails.length != 0 ? "" : "¡Este campo es obligatorio!";
        temp.iva = "";
        temp.comision = "";
        temp.rfc = "";
        temp.motivoajuste = "";
        temp.ajuste = "";
        temp.nivelsiguienteciclo = "";
        temp.gradosiguienteciclo = "";

        if (values.ajuste === "") {
            temp.ajuste = "¡El ajuste debe tener un valor mayor o igual a cero!";
        }


        //console.log("-----vamossss > " + parseFloat(values.ajuste));
        if (parseFloat(values.ajuste) > 0 && values.motivoajuste === "") {
            temp.motivoajuste = "¡Tienes un ajuste mayor a cero, por tanto debes ingresar el motivo de ajuste!";
        }

        if (values.factura == "SI") {
            if (values.rfc == "") {
                temp.rfc = "¡Este campo es obligatorio!";
            }

            if (values.iva == "none") {
                temp.iva = "¡Este campo es obligatorio!";
            }

        }


        if (values.pMethod == "Tarjeta Débito" || values.pMethod == "Tarjeta Crédito") {
            if (values.comision == "none") {
                temp.comision = "¡Este campo es obligatorio!";
            }


        }


        /*
        if (parseInt(values.customerId) === parseInt(cicloescolarsiguenteId)) {
            if (values.nivelsiguienteciclo == "none") {
                temp.nivelsiguienteciclo = "¡Este campo es obligatorio!";
            }
            if (values.gradosiguienteciclo == "none") {
                temp.gradosiguienteciclo = "¡Este campo es obligatorio!";
            }
        }
        */



        setErrors({ ...temp });
        return Object.values(temp).every(x => x === "");
    }




    const submitOrder = e => {
        e.preventDefault();


        if (validateForm()) {
            if (values.orderMasterId == 0) {

                //console.log("---AAAAA------***>" + JSON.stringify(values));


                setEnviarpago(true);
                createAPIEndpoint(ENDPIONTS.ORDER).create(values)
                    .then(res => {
                        //resetForm();
                        setNotify({ isOpen: true, message: '¡El pago ha sido realizado!' });
                        setEnviarpago(false);
                    })
                    .catch(err => console.log(err));

            } else {
                createAPIEndpoint(ENDPIONTS.ORDER).update(values.orderMasterId, values)
                    .then(res => {
                        //setOrderId(0);
                        setNotify({ isOpen: true, message: '¡El pago ha sido realizado!' });
                    })
                    .catch(err => console.log(err));
            }
        }

    }


    const bajarArchivoSiguienteCiclo = id => {
        window.location.href = '/api/Alumno/BajarSiguienteCiclo';
    }


    return (
        <>
            <br />
            <Form onSubmit={submitOrder}>
                <Grid container>

                    {
                        /*
                                             <Grid item xs={3}>
                        <Input
                            disabled
                            label="Número De Folio"
                            name="orderNumber"
                            value={values.orderNumber}
                            InputProps={{
                                startAdornment: <InputAdornment
                                    className={classes.adornmentText}
                                    position="start">#</InputAdornment>
                            }}
                        />

                    </Grid>

                    <Grid item xs={3}>

                        <Input
                            disabled
                            label="Total"
                            name="gTotal"
                            value={values.gTotal}
                            InputProps={{
                                startAdornment: <InputAdornment
                                    className={classes.adornmentText}
                                    position="start">$</InputAdornment>
                            }}
                        />

                    </Grid>

                         */
                    }


                    <Grid item xs={3}>
                        <a onClick={() => bajarArchivoSiguienteCiclo()} style={{ color: "blue" }}>Bajar Archivo <DownloadIcon style={{ color: "blue", cursor: "pointer" }} /></a>
                    </Grid>



                    <Grid item xs={12}>
                        <TableContainer component={Paper}>
                            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center">ID</StyledTableCell>
                                        <StyledTableCell align="center">Nombres</StyledTableCell>
                                        <StyledTableCell align="center">Apellido Paterno</StyledTableCell>
                                        <StyledTableCell align="center">Apellido Materno</StyledTableCell>
                                        <StyledTableCell align="center">Siguiente Nivel</StyledTableCell>
                                        <StyledTableCell align="center">Siguiente Grado</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        alumnoList.map((row) => (
                                            <TableRow
                                                key={row.idalumno}
                                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            >
                                                <StyledTableCell align="center">{row.idalumno}</StyledTableCell>
                                                <StyledTableCell align="center">{row.nombres}</StyledTableCell>
                                                <StyledTableCell align="center">{row.apellidopaterno}</StyledTableCell>
                                                <StyledTableCell align="center">{row.apellidomaterno}</StyledTableCell>
                                                <StyledTableCell align="center">{row.nivelsiguienteciclo}</StyledTableCell>
                                                <StyledTableCell align="center">{row.gradosiguienteciclo}</StyledTableCell>
                                            </TableRow>
                                        ))
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grid>


                </Grid>
            </Form>

            <Notification {...{ notify, setNotify }} />
        </>
    )
}


